<template>
    <div class="activity-div">
       <span class="fa"><img src="/src/assets/img/logo_whited.png"></span>
        <h3>
            <router-link :to="{ name: 'view-news', params: { id: news.Id } }">{{ news.Title }}</router-link>
        </h3>
    </div>
</template>
<script>
export default {
    name: 'ActivityDiv',

    props: ['news']
}
</script>
<style lang="scss" scoped>
    @import "src/assets/sass/shared.scss";

    .activity-div{
        padding:15px 0px;
        @include padding-right(10px);
        border-bottom:1px solid rgba(#fff,0.5) ;
        span.fa{
            @include float-left($dir);
                img{
                    width:25px;
                    margin:2px 6px;
                }
                }
        h3{
            direction:$dir;
            display: inline-block;
            @include multiline-ellipses(16px,1.2,2);
            @include text-align($dir);
            color:#fff;
            
            }
        }

        a {
            color: white;
        }

</style>



// WEBPACK FOOTER //
// src/components/home/latest-activity-div.vue